import { notification } from "antd";
import { call, put } from "redux-saga/effects";
import { Creators as WeightGainProjectionActions } from "../ducks/weightGainProjection";
/** Services */
import {
  getWeightGainProjectionIndex,
  getWeightGainProjectionGroupIndex,
  getWeightGainProjectionShow,
  saveWeightGainProjection,
  saveWeightGainProjectionForGroup,
  inactivateWeightGainProjection,
  activateWeightGainProjection,
} from "../../services/weightGainProjectionService";

export function* indexWeightGainProjection(action) {
  try {
    const { farmId } = action.payload;
    const {
      data: { results },
    } = yield call(
      !farmId ? getWeightGainProjectionGroupIndex : getWeightGainProjectionIndex,
      action.payload
    );
    yield put(WeightGainProjectionActions.indexWeightGainProjectionSuccess(results));
  } catch (error) {
    console.error(error);
    yield put(WeightGainProjectionActions.indexWeightGainProjectionError(error));
  }
}

export function* showWeightGainProjection(action) {
  try {
    const {
      data: { results },
    } = yield call(getWeightGainProjectionShow, action.payload);
    yield put(WeightGainProjectionActions.showWeightGainProjectionSuccess(results));
  } catch (error) {
    yield put(WeightGainProjectionActions.showWeightGainProjectionError(error));
  }
}

export function* saveWeightGainProjectionSaga(action) {
  try {
    const { groupId, farmId, id, saveOptions } = action.payload;

    const {
      data: { results: newWeightGainProjection },
    } = yield call(
      !farmId ? saveWeightGainProjectionForGroup : saveWeightGainProjection,
      action.payload
    );

    if (id == null) {
      notification.success({
        message: "Projeção de ganho de peso criada com sucesso",
      });
    } else {
      notification.success({
        message: "Projeção de ganho de peso atualizada com sucesso",
      });
    }
    yield put(
      WeightGainProjectionActions.saveWeightGainProjectionSuccess(
        newWeightGainProjection,
        saveOptions
      )
    );
    yield put(
      WeightGainProjectionActions.indexWeightGainProjection(groupId, farmId, 0, {}, "", true)
    );
  } catch (error) {
    notification.error({ message: "Projeção de ganho de peso não foi salva" });
    yield put(WeightGainProjectionActions.saveWeightGainProjectionError(error));
  }
}

export function* inactivateOrActivateWeightGainProjection(action) {
  const {
    groupId,
    farmId,
    action: operationAction,
    weightGainProjection,
  } = action.payload;
  try {
    if (operationAction === "inactivate") {
      yield call(inactivateWeightGainProjection, action.payload);
    } else {
      yield call(activateWeightGainProjection, action.payload);
    }
    notification.success({
      message: `Projeção de ganho de peso: ${weightGainProjection.name} foi ${
        operationAction === "inactivate" ? "inativada" : "ativada"
      } com sucesso !`,
    });
    yield put(
      WeightGainProjectionActions.inactivateOrActivateWeightGainProjectionSuccess()
    );
    yield put(
      WeightGainProjectionActions.indexWeightGainProjection(groupId, farmId, 0, {}, "", true)
    );
  } catch (error) {
    notification.error({
      message: `Projeção de ganho de peso: ${weightGainProjection.name} não foi ${
        operationAction === "inactivate" ? "inativada" : "ativada"
      }. Contate o suporte !`,
    });
    yield put(
      WeightGainProjectionActions.inactivateOrActivateWeightGainProjectionError(error)
    );
  }
}
